import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Loader } from 'semantic-ui-react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { UiMessage } from 'stoerk-ui-components';
import Util, {
  saveLocalStorage,
  getValueLocalStore,
} from '../../../../util/Util';
import getAddressesCoordinates from '../../../../redux/addressesCoordinates/actions';
import { withHandlingErrors } from '../../../../handlingErrors';
import { withPolyglot } from '../../../../i18n';
import { withUserRightUtil } from '../../../../util/rights';
import { warmUpGroups } from '../../../../redux/groups/actions/thunks';
import BreadcrumbNew from '../../../commons/breadcrumbNew';
import ConnectMap from './Map';
import { VIEW_MAP, VIEW_LIST } from '../../../commons/topBarMenu';
import './index.css';

const util = new Util();
const showViewGroupsAndDevicesKey = util.getShowViewGroupsAndDevicesKey();

export class MapDevices extends Component {
  constructor(props) {
    super(props);
    this.loadData = this.loadData.bind(this);
    this.closeMap = this.closeMap.bind(this);
    this.state = {
      showLoading: false,
    };
  }

  componentDidMount() {
    /* get the view that has used the user */
    this.view = getValueLocalStore(showViewGroupsAndDevicesKey);
    this.view = !this.view || this.view === VIEW_MAP ? VIEW_LIST : this.view;
    saveLocalStorage(showViewGroupsAndDevicesKey, VIEW_MAP, '/');
    this.loadData();
  }

  closeMap() {
    const { history } = this.props;
    saveLocalStorage(showViewGroupsAndDevicesKey, this.view, '/');
    history.push('/devicemanager');
  }

  /**
   * Load data
   * this function load the coordinates of the devices
   */
  async loadData() {
    const { activatedLoadingGroupsDevices, handlingErrorsApi } = this.props;
    try {
      this.setState({ showLoading: true });
      if (!activatedLoadingGroupsDevices) {
        await this.props.warmUpGroups();
      }
      this.setState({ showLoading: false });
    } catch (error) {
      this.setState({ showLoading: false });
      handlingErrorsApi(error);
    }
  }

  render() {
    const { polyglot, featureToggle } = this.props;
    const { showLoading } = this.state;
    const sectionsNavigation = [
      { content: polyglot.t('button.back'), onClick: () => this.closeMap() },
      { content: polyglot.t('map.title') },
    ];

    if (!showLoading && !featureToggle.map) {
      return (
        <div>
          <BreadcrumbNew sections={sectionsNavigation} />
          <div style={{ textAlign: 'center' }}>
            <UiMessage
              icon="warning sign"
              header={polyglot.t('map.not_rights_to_module_map_header')}
              content={polyglot.t('map.not_rights_to_module_map_content')}
            />
          </div>
        </div>
      );
    }

    return (
      <div>
        <BreadcrumbNew sections={sectionsNavigation} />
        {showLoading ? (
          <Loader active content={polyglot.t('group.loading_data_message')} />
        ) : (
          <ConnectMap />
        )}
      </div>
    );
  }
}

MapDevices.propTypes = {
  handlingErrorsApi: PropTypes.func.isRequired,
  history: PropTypes.shape({
    replace: PropTypes.func.isRequired,
    push: PropTypes.func.isRequired,
    goBack: PropTypes.func.isRequired,
  }).isRequired,
  polyglot: PropTypes.shape({
    t: PropTypes.func,
    locale: PropTypes.func,
  }).isRequired,
  rightsUserUtil: PropTypes.objectOf(PropTypes.func).isRequired,
  warmUpGroups: PropTypes.func.isRequired,
  activatedLoadingGroupsDevices: PropTypes.bool.isRequired,
  featureToggle: PropTypes.objectOf(Object).isRequired,
};

const mapStateToProps = (state) => ({
  activatedLoadingGroupsDevices: state.groups.activatedLoadingGroupsDevices,
  featureToggle: state.featureToggle,
});

export default connect(mapStateToProps, {
  getAddressesCoordinates,
  warmUpGroups,
})(withUserRightUtil(withRouter(withPolyglot(withHandlingErrors(MapDevices)))));
